// --------------------------------------------------------------------------------
import { Component, CSSProperties, ReactElement } from 'react';
import Tooltip from 'rsuite/Tooltip';
import _ from 'lodash';
import ReactDOM from 'react-dom';
// --------------------------------------------------------------------------------
export interface InfotipProps {
    open: boolean;
    content: any;
    xPos: number;
    yPos: number;
    maxWidth?: number;
    style?: CSSProperties;
}
// --------------------------------------------------------------------------------
export class Infotip extends Component<InfotipProps> {
    // ----------------------------------------------------------------------------
    public static defaultProps: InfotipProps = {
        open: false,
        content: '',
        xPos: 0,
        yPos: 0,
        maxWidth: 300,
        style: {}
    }
    // ----------------------------------------------------------------------------
    constructor(props: InfotipProps) {
        super(props);
    }
    // ----------------------------------------------------------------------------
    render(): ReactElement | null | false {
        const { content, open, yPos, xPos, maxWidth, style } = this.props;
        return (
            ReactDOM.createPortal(<Tooltip
                arrow={false}
                visible={open}
                style={{
                    zIndex: 5000,
                    top: yPos,
                    left: xPos,
                    maxWidth: maxWidth ?? 300,
                    ...style
                }}>
                {content}
            </Tooltip>, document.body)
        );
    }
}
// --------------------------------------------------------------------------------